module.exports = __webpack_public_path__ + "static/media/activity-icon.a07aa191.svg";